
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.333 4.167a.833.833 0 01.834-.834H9.31c.221 0 .433.088.59.245l6.666 6.666a.834.834 0 010 1.179l-5.143 5.143a.834.834 0 01-1.179 0L3.577 9.899a.833.833 0 01-.244-.589V4.167zm.834-2.5a2.5 2.5 0 00-2.5 2.5V9.31a2.5 2.5 0 00.732 1.767l6.667 6.666a2.5 2.5 0 003.535 0l5.143-5.141a2.5 2.5 0 000-3.536l-6.666-6.667a2.5 2.5 0 00-1.768-.732H4.167zM5.833 5a.833.833 0 000 1.667h.009a.833.833 0 000-1.667h-.009z"}})])
          )
        }
      }
    